import React from 'react';
import { motion } from 'framer-motion';
import { painPoints, planningQuestions } from '../data/painPoints';
export function PainPoints() {
  return <section className="py-24 px-4 bg-white" data-id="element-139" data-mp="2lmj1x3tsf9h9">
      <div className="max-w-4xl mx-auto" data-id="element-140" data-mp="26yxxn6l6f47r">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center mb-12" data-id="element-141" data-mp="26y5zbo072sds">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-blue-950" data-id="element-142" data-mp="21zlaekqe7v4n">
            Does this sound familiar?
          </h2>
          <div className="text-lg text-slate-700 leading-relaxed bg-white p-6 rounded-2xl border border-amber-500/40 shadow-sm shadow-blue-700/10 text-left space-y-4" data-id="element-143" data-mp="1o1eidl84kpcw">
            <p data-id="element-144" data-mp="3iemls1a629a5">Another Olympic Weightlifting session is coming.</p>
            <p data-id="element-145" data-mp="3ncfpmnnzyr79">
              And instead of disconnecting at the end of the day, you are still searching for
              drills, deciding what technical problem to work on, looking for Snatch progressions,
              organizing Clean &amp; Jerk work, choosing accessories and trying to turn everything
              into a session that actually makes sense.
            </p>
            <p data-id="element-146" data-mp="27utc2pmwg2ls">
              <span className="text-blue-950 font-semibold" data-id="element-147" data-mp="23rnb9xik33mp">
                Not because you don&apos;t understand Olympic Weightlifting.
              </span>{' '}
              Because knowing the sport and having a complete visual coaching system ready to use
              are two different things.
            </p>
            <p className="text-blue-950 font-semibold" data-id="element-148" data-mp="1p2r5660280oq">
              Without a clear system, every training day can turn into the same process:
            </p>
            <ul className="space-y-1.5 pl-1" data-id="element-149" data-mp="1k5qzhw74gzy5">
              {planningQuestions.map(question => <li key={question} className="flex items-start gap-2 italic" data-id="element-150" data-mp="30jh6bapmm2bh">
                  <span className="text-amber-500 not-italic" aria-hidden="true" data-id="element-151" data-mp="2vibb968hu2ys">
                    ?
                  </span>
                  {question}
                </li>)}
            </ul>
            <p data-id="element-152" data-mp="1y6cii7qzhx35">And then you start again the next day.</p>
            <p data-id="element-153" data-mp="226wh7fr7h8re">
              The time you should be spending coaching, reviewing athlete progress or simply
              disconnecting becomes planning time.
            </p>
            <p data-id="element-154" data-mp="1af74ly4ltevh">
              And the hardest part is not only the time.{' '}
              <span className="text-blue-950 font-semibold" data-id="element-155" data-mp="1eg8sxjwzg6io">
                It is entering the gym knowing you could have been more prepared.
              </span>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-156" data-mp="1o5sfp0ntgkit">
          <h3 className="text-xl font-serif font-bold text-blue-950 mb-8 text-center" data-id="element-157" data-mp="vozmjjiidxvb">
            The real cost of planning everything from scratch:
          </h3>
          <div className="overflow-hidden rounded-xl border border-amber-500/40 bg-white shadow-sm shadow-blue-700/10" data-id="element-158" data-mp="j75j68lcgbq9">
            {painPoints.map((point, index) => <motion.p key={point} initial={{
            opacity: 0,
            x: -12
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="px-5 py-4 text-slate-700 text-sm leading-relaxed border-t first:border-t-0 border-amber-500/30" data-id="element-159" data-mp="e697v9ynxnat" data-mpi={index}>
                <span className="mr-2 text-amber-500" data-id="element-160" data-mp="3mnvxdar2xv31">●</span>
                {point}
              </motion.p>)}
          </div>

          <div className="text-center mt-12 pt-8 border-t border-amber-500/30" data-id="element-161" data-mp="3il918xndlo01">
            <p className="text-2xl font-serif font-bold text-blue-950" data-id="element-162" data-mp="3dmxoae1saxdl">
              Your coaching knowledge is already there. What you need is a{' '}
              <span className="text-amber-600" data-id="element-163" data-mp="1hm5o626bo3ta">system</span> that helps you SEE, ORGANIZE and APPLY
              it faster and more consistently.
            </p>
            <p className="text-xl mt-4 text-blue-700 font-semibold" data-id="element-164" data-mp="17t6qzvwrf4y2">
              Solve your Olympic Weightlifting coaching sessions in just 5 MINUTES
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}